import {Currency} from "@/models/Security/Currency";

function filterBy (list, value) {
    return list.filter(function(user){
        return user.business_name.toLowerCase().indexOf(value) >= 0;
    });
}

function formatPrice (value) {
    let val = (value/1).toFixed(2)
    return Currency.format(parseFloat(val));
}

function formatPriceProject (value) {
    let val = (value/1).toFixed(0)
    return Currency.format(parseFloat(val));
}

function parseValue(string) {
    var pattern = /\$|\,/ig;
    return parseInt(string.replace(pattern, ''))
}

function parseFloatValue(string) {
    var pattern = /\$|\,/ig;
    return parseFloat(string.replace(pattern, ''))
}

export {filterBy, formatPrice, parseValue, formatPriceProject, parseFloatValue}
